export const LOCALSTORAGE_TOKEN = 'LOCALSTORAGE_TOKEN';
export const LOCALSTORAGE_USERDETAIL = 'LOCALSTORAGE_USERDETAIL';
